// 意味は「最後に自動表示した時刻」。キー名は既存ユーザーの抑制状態を引き継ぐため従来のまま流用する。
const STARTUP_POPUP_SHOWN_AT_KEY = "startup_second_opinion_popup_dismissed_at";
const SUPPRESS_DAYS = 7;
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export class StartupPopupManager {
  static shouldShowAtLaunch(): boolean {
    if (typeof window === "undefined" || !window.localStorage) return false;

    const raw = window.localStorage.getItem(STARTUP_POPUP_SHOWN_AT_KEY);
    if (!raw) return true;

    const shownAt = new Date(raw);
    if (Number.isNaN(shownAt.getTime())) return true;

    const elapsed = Date.now() - shownAt.getTime();
    return elapsed >= SUPPRESS_DAYS * ONE_DAY_MS;
  }

  // 自動表示したタイミングで記録する（閉じずにアプリを終了しても週1表示を保証するため）。
  static markShownNow(): void {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.setItem(STARTUP_POPUP_SHOWN_AT_KEY, new Date().toISOString());
  }
}
